import Topbar from "../../components/Topbar/Topbar";
import CardContainer from '../../components/LeftContainer/LeftContainer';
import LotteryDrumSection from "../../components/LotterDrumSection/LotteryDrumSection";
import WinnerCard from "../../components/WinnerCard/WinnerCard";
//import { useGameStateStore } from "../../stores/gameStateStore";
import { getBalance } from "../../api/API";
import { useEffect } from "react";


export default function GamePage() {
  // const setGameState = useGameStateStore.getState().setGameState;
  async function getGameInfo() {
    const gState = await getBalance();
    console.log(gState, "balance");
  }
  useEffect(() => {
    setTimeout(() => {
      getGameInfo();
    }, 3000);
  }, [])

  return (
    <>
      <WinnerCard />
      <Topbar />
      <div style={{ display: "flex" }}>
        <CardContainer flexValue={11} />
        <LotteryDrumSection flexValue={6} />
      </div>
    </>
  )
}